<template>
  <q-dialog v-model="edit">
    <q-card>
      <q-form @submit.prevent="onSubmit" ref="myForm" class="flexbox">
        <div class="q-pa-md">
          <div class="row q-col-gutter-md">
            <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
              <span class="label-input">Vehicle*</span>
              <q-select
                outlined
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                disable
                style="overflow: hidden !important"
                :option-label="
                  vehicle =>
                    vehicle.brand && vehicle.brand.name
                      ? `${vehicle.brand.name}#${vehicle.model.name}#${vehicle.vin}`
                      : ''
                "
                v-model="selectedVehicle"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template>
                <template v-slot:prepend>
                  <q-icon name="fas fa-user-tie" size="16px" color="grey-7"></q-icon>
                </template>
              </q-select>
            </div>
            <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
              <span class="label-input">Mileage*</span>
              <q-input
                type="number"
                outlined
                v-model="millage"
                lazy-rules
                :rules="[val => (val !== null && val !== '') || 'Please type mils value']"
              ></q-input>
            </div>
            <div class="mt-5 flex-end q-gutter-xs">
              <q-btn :loading="loading" label="Save" :disable="loading" type="submit" color="positive">
                <template v-slot:loading>
                  <q-spinner-facebook />
                </template>
              </q-btn>
            </div>
          </div>
        </div>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from '../axios/index'
export default {
  metaInfo() {
    return {
      title: `${this.metaTag} | FMS`,
      // title: "FMS - Build your network in your field of interest",
      meta: [
        {
          name: 'description',
          // "FMS is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
          content: ''
        },
        {
          property: 'og:title',
          content: `${this.metaTag} | FMS`
        },
        { property: 'og:site_name', content: 'FMS' },
        { property: 'og:type', content: 'website' },
        { name: 'robots', content: 'index,follow' }
      ]
    }
  },
  data() {
    return {
      loading: false,
      price: '',
      millage: '',
      date: ''
    }
  },
  methods: {
    async onSubmit() {
      try {
        this.loading = true
        const body = {
          date: new Date().toISOString().slice(0, 10),
          mileage: this.millage
        }
        const { data } = await axios.patch(`vehicle-mileage-record/${this.selectedMillage.id}`, body)
        this.$store.commit('millage/EDIT_MILLAGE', {
          ...this.selectedMillage,
          id: this.selectedMillage.id,
          date: new Date().toISOString().slice(0, 10),
          mileage: parseFloat(this.millage)
        })
        this.$q.notify({
          message: data.data.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
        this.edit = false
      } catch (error) {
        const { message } = error.response.data
        this.$q.notify({
          message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    selectedMillage: {
      deep: true,
      handler(n, o) {
        if (n.id) {
          console.log(n)
          this.millage = n.mileage
          this.date = n.date
        }
      }
    }
  },
  computed: {
    metaTag() {
      if (this.edit) {
        return `${
          this.selectedVehicle && this.selectedVehicle.brand && this.selectedVehicle.brand.name
            ? this.selectedVehicle.brand.name
            : ''
        }#${this.selectedVehicle && this.selectedVehicle.vin ? this.selectedVehicle.vin : ''}`
      } else {
        return 'Adjustment page for Mileage and MMR information regarding on Current Fleet'
      }
    },
    selectedVehicle() {
      return this.$store.state.millage.selectedVehicle
    },
    selectedMillage: {
      get() {
        return this.$store.state.millage.selectedMillage
      },
      set(val) {
        this.$store.commit('millage/EDIT_MILLAGE', val)
      }
    },
    edit: {
      get() {
        return this.$store.state.millage.edit
      },
      set(val) {
        this.$store.commit('millage/SET_EDIT', val)
      }
    }
  }
}
</script>
